import {
    AddRuleRequest,
    RuleListRequest,
    RuleListResponse,
} from 'types/rule/rule';
import { apiSlice } from 'store/slices/api/api-slice';

export const creatRule = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addRule: builder.mutation<void, AddRuleRequest>({
            query: (addRuleRequest: AddRuleRequest) => ({
                url: `/rule/save-rule/`,
                method: 'POST',
                body: { ...addRuleRequest },
            }),
        }),

        updateRule: builder.mutation<void, AddRuleRequest>({
            query: (addRuleRequest: AddRuleRequest) => ({
                url: `/rule/update-rule/` + addRuleRequest.ruleId,
                method: 'PUT',
                body: { ...addRuleRequest },
            }),
        }),

        ruleList: builder.query<RuleListResponse, RuleListRequest>({
            query: (params) => ({
                url: '/rule/rule-list',
                method: 'GET',
                params,
            }),
        }),
    }),
});
export const {
    useAddRuleMutation,
    useLazyRuleListQuery,
    useUpdateRuleMutation,
} = creatRule;
